import { render, staticRenderFns } from "./BackupsTableItemSkeletonMobile.vue?vue&type=template&id=07711520&scoped=true"
import script from "./BackupsTableItemSkeletonMobile.vue?vue&type=script&lang=js"
export * from "./BackupsTableItemSkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./BackupsTableItemSkeletonMobile.vue?vue&type=style&index=0&id=07711520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07711520",
  null
  
)

export default component.exports